import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddTiendaNubeStoreForm} from "./AddTiendaNubeStoreForm";
import {TiendaNubeLogo} from "../../logos/TiendaNubeLogo";
import { withTranslation } from 'react-i18next';

class AddTiendaNubeStoreModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newStoreData) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newStoreData);
    }

    render() {
        const { t } = this.props;
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}><TiendaNubeLogo/>&nbsp;{t('add_store_modal.connect_with_tienda_nube')}</ModalHeader>
                <AddTiendaNubeStoreForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                  clientId={this.props.clientId}
                                  clientName={this.props.clientName}/>
            </Modal>
        );
    }
}

export const AddTiendaNubeStoreModal = withTranslation()(AddTiendaNubeStoreModalClass);

